var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order_box",
      attrs: {
        visible: _vm.modals,
        title: "修改快递单号",
        "before-close": _vm.handleClose,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.modals = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formItem",
          attrs: {
            model: _vm.formItem,
            "label-width": "110px",
            rules: _vm.rules,
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "快递公司：", prop: "expressCode" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "80%" },
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.formItem.expressCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.formItem, "expressCode", $$v)
                    },
                    expression: "formItem.expressCode",
                  },
                },
                _vm._l(_vm.express, function (item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { value: item.code, label: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "快递单号：", prop: "expressNumber" } },
            [
              _c("el-input", {
                staticStyle: { width: "80%" },
                attrs: { placeholder: "请输入快递单号" },
                model: {
                  value: _vm.formItem.expressNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.formItem, "expressNumber", $$v)
                  },
                  expression: "formItem.expressNumber",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "" } }, [
            _c("div", { staticStyle: { color: "#333333" } }, [
              _vm._v("原快递公司：" + _vm._s(_vm.oldName)),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { color: "#333333" } }, [
              _vm._v("原快递单号：" + _vm._s(_vm.oldNum)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.putSend("formItem")
                },
              },
            },
            [_vm._v("提交")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel("formItem")
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }